type ToastType = 'success' | 'error' | 'info' | 'warning';

interface ToastOptions {
  duration?: number;
  position?: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left' | 'top-center' | 'bottom-center';
}

const defaultOptions: ToastOptions = {
  duration: 3000,
  position: 'bottom-right',
};

const TOAST_CONTAINER_Z_INDEX = '1100000';

function createToast(message: string, type: ToastType, options: ToastOptions = {}) {
  const { duration, position } = { ...defaultOptions, ...options };

  const container = getOrCreateContainer(position!);

  const toast = document.createElement('div');
  toast.className = `toast show align-items-center text-bg-${type === 'error' ? 'danger' : type} border-0`;
  toast.setAttribute('role', 'alert');
  toast.setAttribute('aria-live', 'assertive');
  toast.setAttribute('aria-atomic', 'true');

  toast.innerHTML = `
    <div class="d-flex">
      <div class="toast-body">
        ${message}
      </div>
      <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
    </div>
  `;

  container.appendChild(toast);

  const closeButton = toast.querySelector('.btn-close');
  closeButton?.addEventListener('click', () => {
    toast.classList.remove('show');
    setTimeout(() => toast.remove(), 300);
  });

  setTimeout(() => {
    toast.classList.remove('show');
    setTimeout(() => toast.remove(), 300);
  }, duration);
}

function getOrCreateContainer(position: string): HTMLElement {
  const existingContainer = document.querySelector(`.toast-container-${position}`);
  if (existingContainer) {
    return existingContainer as HTMLElement;
  }

  const container = document.createElement('div');
  container.className = `toast-container position-fixed p-3 toast-container-${position}`;
  container.style.zIndex = TOAST_CONTAINER_Z_INDEX;

  switch (position) {
    case 'top-right':
      container.style.top = '0';
      container.style.right = '0';
      break;
    case 'top-left':
      container.style.top = '0';
      container.style.left = '0';
      break;
    case 'bottom-right':
      container.style.bottom = '0';
      container.style.right = '0';
      break;
    case 'bottom-left':
      container.style.bottom = '0';
      container.style.left = '0';
      break;
    case 'top-center':
      container.style.top = '0';
      container.style.left = '50%';
      container.style.transform = 'translateX(-50%)';
      break;
    case 'bottom-center':
      container.style.bottom = '0';
      container.style.left = '50%';
      container.style.transform = 'translateX(-50%)';
      break;
  }

  document.body.appendChild(container);
  return container;
}

export const toast = {
  success: (message: string, options?: ToastOptions) => createToast(message, 'success', options),
  error: (message: string, options?: ToastOptions) => createToast(message, 'error', options),
  info: (message: string, options?: ToastOptions) => createToast(message, 'info', options),
  warning: (message: string, options?: ToastOptions) => createToast(message, 'warning', options),
};
